export default __webpack_public_path__ + "static/media/tourlyFacebook-1200x630.cd675ab7.jpg";